// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpyCard {
  display: flex;
  align-items: center; }
  .SpyCard .spy-grid {
    background-color: black;
    border-radius: 12px;
    display: grid;
    grid-template-columns: 150px 150px 150px 150px 150px;
    grid-template-rows: 125px 125px 125px 125px;
    padding: 15px; }
    .SpyCard .spy-grid .cell {
      border-radius: 12px;
      margin: 10px;
      display: flex;
      justify-content: center;
      align-items: center; }
      .SpyCard .spy-grid .cell.red {
        background: red;
        background: radial-gradient(circle, #ff4d4d 0%, red 100%); }
      .SpyCard .spy-grid .cell.blue {
        background: #0095ff;
        background: radial-gradient(circle, #4db5ff 0%, #0095ff 100%); }
      .SpyCard .spy-grid .cell.green {
        background: #00b106;
        background: radial-gradient(circle, #00fe09 0%, #00b106 100%); }
      .SpyCard .spy-grid .cell.black {
        background: #292929;
        background: radial-gradient(circle, #4f4f4f 0%, #292929 100%); }
      .SpyCard .spy-grid .cell:before {
        font-weight: 900;
        font-size: 3rem; }
      .SpyCard .spy-grid .cell.neutral {
        background-color: #daca9e; }
    @media only screen and (max-width: 900px) {
      .SpyCard .spy-grid {
        grid-template-columns: 100px 100px 100px 100px 100px;
        grid-template-rows: 75px 75px 75px 75px; } }
    @media only screen and (max-width: 650px) {
      .SpyCard .spy-grid {
        grid-template-columns: 75px 75px 75px 75px 75px;
        grid-template-rows: 55px 55px 55px 55px; } }
    @media only screen and (max-width: 525px) {
      .SpyCard .spy-grid {
        grid-template-columns: 15vw 15vw 15vw 15vw 15vw;
        grid-template-rows: 12vw 12vw 12vw 12vw;
        padding: 10px; } }
  .SpyCard .starting-color {
    border-radius: 8px;
    height: 100px;
    margin: 15px;
    width: 30px; }
    .SpyCard .starting-color.red {
      background: red;
      background: radial-gradient(circle, #ff4d4d 0%, red 100%); }
    .SpyCard .starting-color.blue {
      background: #0095ff;
      background: radial-gradient(circle, #4db5ff 0%, #0095ff 100%); }
    .SpyCard .starting-color.green {
      background: #00b106;
      background: radial-gradient(circle, #00fe09 0%, #00b106 100%); }
    .SpyCard .starting-color.black {
      background: #292929;
      background: radial-gradient(circle, #4f4f4f 0%, #292929 100%); }
    @media only screen and (max-width: 650px) {
      .SpyCard .starting-color {
        height: 60px;
        margin: 10px;
        width: 20px; } }
`, "",{"version":3,"sources":["webpack://./src/components/SpyCard.scss","webpack://./src/style/colors.scss"],"names":[],"mappings":"AAYA;EACE,aAAa;EACb,mBAAmB,EAAA;EAFrB;IAKI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,oDAAoD;IACpD,2CAA2C;IAC3C,aAAa,EAAA;IAVjB;MAaM,mBAAmB;MACnB,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB,EAAA;MAxBrB;QACE,eCHqB;QDIrB,yDAA6D,EAAA;MAF/D;QACE,mBCJwB;QDKxB,6DAA6D,EAAA;MAF/D;QACE,mBCDuB;QDEvB,6DAA6D,EAAA;MAF/D;QACE,mBCkBc;QDjBd,6DAA6D,EAAA;MAKnE;QAqBQ,gBAAgB;QAChB,eAAe,EAAA;MAtBvB;QA0BQ,yBAAyB,EAAA;IAI7B;MA9BJ;QA+BM,oDAAoD;QACpD,uCAAuC,EAAA,EAa1C;IAVC;MAnCJ;QAoCM,+CAA+C;QAC/C,uCAAuC,EAAA,EAQ1C;IALC;MAxCJ;QAyCM,+CAA+C;QAC/C,uCAAuC;QACvC,aAAa,EAAA,EAEhB;EA7CH;IAgDI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW,EAAA;IA1DX;MACE,eCHqB;MDIrB,yDAA6D,EAAA;IAF/D;MACE,mBCJwB;MDKxB,6DAA6D,EAAA;IAF/D;MACE,mBCDuB;MDEvB,6DAA6D,EAAA;IAF/D;MACE,mBCkBc;MDjBd,6DAA6D,EAAA;IA2D/D;MAtDJ;QAuDM,YAAY;QACZ,YAAY;QACZ,WAAW,EAAA,EAEd","sourcesContent":["@import \"./../style/colors\";\n\n@mixin team-gradient {\n  @each $name, $hex in $spyCardCellColors {\n    $lightened: lighten($hex, 15%);\n    &.#{$name} {\n      background: $hex;\n      background: radial-gradient(circle, $lightened 0%, $hex 100%);\n    }\n  }\n}\n\n.SpyCard {\n  display: flex;\n  align-items: center;\n\n  .spy-grid {\n    background-color: black;\n    border-radius: 12px;\n    display: grid;\n    grid-template-columns: 150px 150px 150px 150px 150px;\n    grid-template-rows: 125px 125px 125px 125px;\n    padding: 15px;\n\n    .cell {\n      border-radius: 12px;\n      margin: 10px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      @include team-gradient();\n\n      &:before {\n        font-weight: 900;\n        font-size: 3rem;\n      }\n\n      &.neutral {\n        background-color: #daca9e;\n      }\n    }\n\n    @media only screen and (max-width: 900px) {\n      grid-template-columns: 100px 100px 100px 100px 100px;\n      grid-template-rows: 75px 75px 75px 75px;\n    }\n\n    @media only screen and (max-width: 650px) {\n      grid-template-columns: 75px 75px 75px 75px 75px;\n      grid-template-rows: 55px 55px 55px 55px;\n    }\n\n    @media only screen and (max-width: 525px) {\n      grid-template-columns: 15vw 15vw 15vw 15vw 15vw;\n      grid-template-rows: 12vw 12vw 12vw 12vw;\n      padding: 10px;\n    }\n  }\n\n  .starting-color {\n    border-radius: 8px;\n    height: 100px;\n    margin: 15px;\n    width: 30px;\n    @include team-gradient();\n\n    @media only screen and (max-width: 650px) {\n      height: 60px;\n      margin: 10px;\n      width: 20px;\n    }\n  }\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
